import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    formataValor,
    formataPerc,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3,
    GridItem4,
    GridItem6,
    GridItem8,
    GridItem9,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorText,
    TextValidatorValor,
    TextValidatorValorRequired,
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorMesAnoRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelectRequired,
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    IconButtonEditar,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import administradoraConsorcioList from '../../../business-rules/List/Consorcio/administradoraConsorcioList'

import formaAbaterLanceList from '../../../business-rules/List/Consorcio/formaAbaterLanceList'

//import tipoGrupoConsorcioList from '../../../business-rules/List/Consorcio/tipoGrupoConsorcioList'

import pessoaFisicaJuridicaList from '../../../business-rules/List/Consorcio/pessoaFisicaJuridicaList'



const ConsorcioSimulacaoLabelCampo = ({ label }) => {

    return (
        <h5
            className='mt-5 text-muted'
        >
            {label}
        </h5>
    )
}

const ConsorcioSimulacaoLabelPerc = () => {

    return (
        <div
            className='mt-6 text-muted'
        >
            {LABEL.perc}
        </div>
    )
}

const ConsorcioSimulacaoLabelVezes = () => {

    return (
        <div
            className='mt-4'
        >
            {LABEL.vezes}
        </div>
    )
}

const ConsorcioSimulacaoCampoTexto = ({ texto }) => {

    return (
        <h6
            className='mt-5'
        >
            {texto}
        </h6>
    )
}

const ConsorcioSimulacaoCampoValor = ({ valor }) => {

    return (
        <h6
            className='mt-5'
        >
            {formataValor(round(valor, 2), 2)}
        </h6>
    )
}

const ConsorcioSimulacaoCampoNumero = ({ numero }) => {

    return (
        <h6
            className='mt-5'
        >
            {numero}
        </h6>
    )
}

const ConsorcioSimulacaoCampoPerc = ({ perc, report }) => {

    return (
        <div
            className={(report ? 'mt-5' : 'mt-6') + ' text-12'}
        >
            {formataPerc(perc, 2)}
        </div>
    )
}

const ConsorcioSimulacaoCampoPercInput = ({ perc, casasDecimais }) => {

    return (
        <h6
            className='mt-5'
        >
            {formataPerc(perc, casasDecimais ? casasDecimais : 2)}
        </h6>
    )
}


export const ConsorcioSimulacaoInputList = ({ label, Componente, params, naoExibirLabelReport }) => {

    return (
        <GridContainer>
            <GridItem1/>

            {(!params.report || !naoExibirLabelReport) && (
                <GridItem6>
                    <ConsorcioSimulacaoLabelCampo
                        label={label}
                    />
                </GridItem6>
            )}

            <GridItem4>
                <Componente
                    item={params.item}
                    ind={params.ind}
                    handleChange={params.handleChange}
                    params={params}
                    report={params.report}
                />
            </GridItem4>
        </GridContainer>
    )
}

export const ConsorcioSimulacaoInputText = ({ label, Componente, params }) => {

    return (
        <GridContainer>
            <GridItem1/>

            <GridItem6>
                <ConsorcioSimulacaoLabelCampo
                    label={label}
                />
            </GridItem6>

            <GridItem3>
                <Componente
                    item={params.item}
                    ind={params.ind}
                    handleChange={params.handleChange}
                    report={params.report}
                />
            </GridItem3>
        </GridContainer>
    )
}

export const ConsorcioSimulacaoInputListValor = ({ label, Componente, params, list, valor }) => {

    const GridItemComponente = params.report ? GridItem2 : GridItem3

    return (
        <GridContainer>
            <GridItem1/>

            <GridItem6>
                <ConsorcioSimulacaoLabelCampo
                    label={label}
                />
            </GridItem6>

            <GridItemComponente>
                <Componente
                    item={params.item}
                    ind={params.ind}
                    handleChange={params.handleChange}
                    list={list}
                    report={params.report}
                />
            </GridItemComponente>

            <GridItem2
                 style={{
                    marginTop: params.report ? '1px' : '6.5px'
                }}
            >
                <ConsorcioSimulacaoCampoValor
                    valor={valor}
                />
            </GridItem2>
        </GridContainer>
    )
}

export const ConsorcioSimulacaoInputValor = ({ label, Componente, params, perc }) => {

    return (
        <GridContainer>
            <GridItem1/>

            <GridItem6>
                <ConsorcioSimulacaoLabelCampo
                    label={label}
                />
            </GridItem6>

            <GridItem3>
                <Componente
                    item={params.item}
                    ind={params.ind}
                    handleChange={params.handleChange}
                    report={params.report}
                />
            </GridItem3>

            {perc && (
                <GridItem1>
                    <ConsorcioSimulacaoCampoPerc
                        perc={perc}
                        report={params.report}
                    />
                </GridItem1>
            )}
        </GridContainer>
    )
}

export const ConsorcioSimulacaoListInputPerc = ({ ComponenteList, list, Componente, params, valor }) => {

    return (
        <GridContainer>
            <GridItem1/>

            <GridItem6>
                <ComponenteList
                    item={params.item}
                    ind={params.ind}
                    handleChange={params.handleChange}
                    list={list}
                    report={params.report}
                />
            </GridItem6>

            <GridItem2>
                <GridContainer>
                    <GridItem9>
                        <Componente
                            item={params.item}
                            ind={params.ind}
                            handleChange={params.handleChange}
                            report={params.report}
                        />
                    </GridItem9>

                    {!params.report && (
                        <GridItem1>
                            <ConsorcioSimulacaoLabelPerc/>
                        </GridItem1>
                    )}
                </GridContainer>
            </GridItem2>

            {valor && (
                <GridItem3>
                    <ConsorcioSimulacaoCampoValor
                        valor={valor}
                        report={params.report}
                    />
                </GridItem3>
            )}
        </GridContainer>
    )
}

export const ConsorcioSimulacaoInputNumero = ({ label, Componente, params}) => {

    return (
        <GridContainer>
            <GridItem1/>

            <GridItem6>
                <ConsorcioSimulacaoLabelCampo
                    label={label}
                />
            </GridItem6>

            <GridItem2>
                <Componente
                    item={params.item}
                    ind={params.ind}
                    handleChange={params.handleChange}
                    report={params.report}
                />
            </GridItem2>
        </GridContainer>
    )
}

export const ConsorcioSimulacaoInputPerc = ({ label, Componente, params, valor, numero, editar, editarPopupTitle, EditarComponente,
    EditarPopupButtonAction, editarPopupButtonActionCondition, editarPopupButtonActionOnclick }) => {

    return (
        <GridContainer>
            <GridItem1/>

            <GridItem6>
                <ConsorcioSimulacaoLabelCampo
                    label={label}
                />
            </GridItem6>

            <GridItem2>
                <GridContainer>
                    <GridItem9>
                        <Componente
                            item={params.item}
                            ind={params.ind}
                            handleChange={params.handleChange}
                            report={params.report}
                        />
                    </GridItem9>

                    {!params.report && (
                        <GridItem1>
                            <ConsorcioSimulacaoLabelPerc/>
                        </GridItem1>
                    )}
                </GridContainer>
            </GridItem2>

            <GridItem3
                style={{
                    marginTop: params.report ? '1px' : '6.5px'
                }}
            >
                <GridContainer>
                    <GridItem9>
                        {valor
                            ?
                                <ConsorcioSimulacaoCampoValor
                                    valor={valor}
                                />
                            :
                                <ConsorcioSimulacaoCampoNumero
                                    numero={numero}
                                />
                        }
                    </GridItem9>

                    <GridItem3
                        className='mt-2'
                    >
                        {editar && (
                            <CustomizedDialogsPopup
                                maxWidth='sm'
                                popupTitle={editarPopupTitle}
                                PopupButton={IconButtonEditar}
                                //bgDefault={true}
                                popupComponent={
                                    <EditarComponente
                                        item={params.item}
                                        ind={params.ind}
                                        handleChange={params.handleChange}
                                    />
                                }
                                PopupButtonAction={EditarPopupButtonAction}
                                popupButtonActionCondition={editarPopupButtonActionCondition}
                                popupButtonActionOnclick={() => {
                                    editarPopupButtonActionOnclick()
                                }}
                            />
                        )}
                    </GridItem3>
                </GridContainer>
            </GridItem3>
        </GridContainer>
    )
}

export const ConsorcioSimulacaoInputCheckboxMeses = ({ label, Componente, label2, Componente2, exibirComponente2,
    label3, Componente3, params, label4, Componente4, label5, Componente5, label6, Componente6}) => {

    return (
        <>
            <GridContainer
                className='mb-2'
            >
                <GridItem1/>

                <GridItem6>
                    <Componente
                        label={label}
                        item={params.item}
                        ind={params.ind}
                        handleChange={params.handleChange}
                        report={params.report}
                    />
                </GridItem6>

                {exibirComponente2 && (
                    <>
                        <GridItem2>
                            {label4 || !label3
                                ?
                                    <Componente2
                                        label={label2}
                                        item={params.item}
                                        ind={params.ind}
                                        handleChange={params.handleChange}
                                        report={params.report}
                                    />
                                :
                                    <GridContainer>
                                        <GridItem9>
                                            <Componente2
                                                label={label2}
                                                item={params.item}
                                                ind={params.ind}
                                                handleChange={params.handleChange}
                                                report={params.report}
                                            />
                                        </GridItem9>
                                    </GridContainer>
                            }
                            
                        </GridItem2>

                        {label3 && (
                            <GridItem3>
                                <GridContainer>
                                    <GridItem8>
                                        <Componente3
                                            label={label3}
                                            item={params.item}
                                            ind={params.ind}
                                            handleChange={params.handleChange}
                                            report={params.report}
                                        />
                                    </GridItem8>
                                </GridContainer>
                            </GridItem3>
                        )}
                    </>
                )}
            </GridContainer>

            {exibirComponente2 && label4 && (
                <GridContainer
                    className='mt--5'
                >
                    <GridItem1/>

                    <GridItem6/>

                    <GridItem2>
                        <Componente4
                            label={label4}
                            item={params.item}
                            ind={params.ind}
                            handleChange={params.handleChange}
                            report={params.report}
                        />
                    </GridItem2>

                    {label5 && (
                        <GridItem2>
                            <Componente5
                                label={label5}
                                item={params.item}
                                ind={params.ind}
                                handleChange={params.handleChange}
                                report={params.report}
                            />
                        </GridItem2>
                    )}
                </GridContainer>
            )}

            {exibirComponente2 && label6 && (
                <GridContainer
                    className='mt--2'
                >
                    <GridItem1/>

                    <GridItem6/>

                    <GridItem4>
                        <Componente6
                            label={label6}
                            item={params.item}
                            ind={params.ind}
                            handleChange={params.handleChange}
                            report={params.report}
                        />
                    </GridItem4>
                </GridContainer>
            )}
        </>
    )
}


export const ConsorcioSimulacaoInputMesAnoPerc = ({ label, label2, Componente2, exibirComponente2,
    label3, Componente3, params }) => {

    return (
        <>
            <GridContainer
                className='mb-2'
            >
                <GridItem1/>

                <GridItem6>
                    <ConsorcioSimulacaoLabelCampo
                        label={label}
                    />
                </GridItem6>

                {exibirComponente2 && (
                    <>
                        <GridItem2>
                            <Componente2
                                label={label2}
                                item={params.item}
                                ind={params.ind}
                                handleChange={params.handleChange}
                                report={params.report}
                            />
                        </GridItem2>

                        {label3 && (
                            <GridItem3>
                                <GridContainer>
                                    <GridItem8>
                                        <Componente3
                                            label={label3}
                                            item={params.item}
                                            ind={params.ind}
                                            handleChange={params.handleChange}
                                            report={params.report}
                                        />
                                    </GridItem8>
                                </GridContainer>
                            </GridItem3>
                        )}
                    </>
                )}
            </GridContainer>
        </>
    )
}


export const ConsorcioSimulacaoExibeValor = ({ label, params, valor, perc}) => {

    return (
        <GridContainer>
            <GridItem1/>

            <GridItem6>
                <ConsorcioSimulacaoLabelCampo
                    label={label}
                />
            </GridItem6>

            <GridItem3>
                <ConsorcioSimulacaoCampoValor
                    valor={valor}
                /> 
            </GridItem3>

            {perc && (
                <GridItem1
                    className='mt--1'
                >
                    <ConsorcioSimulacaoCampoPerc
                        perc={perc}
                        report={params.report}
                    />
                </GridItem1>
            )}
        </GridContainer>
    )
}

export const ConsorcioSimulacaoExibeNumeroValor = ({ label, numero, valor}) => {

    return (
        <GridContainer>
            <GridItem1/>

            <GridItem6>
                <ConsorcioSimulacaoLabelCampo
                    label={label}
                />
            </GridItem6>

            <GridItem2>
                <GridContainer>
                    <GridItem6>
                        <ConsorcioSimulacaoCampoNumero
                            numero={numero}
                        />
                    </GridItem6>

                    <GridItem6>
                        <ConsorcioSimulacaoLabelVezes/>
                    </GridItem6>
                </GridContainer>
            </GridItem2>

            <GridItem3>
                <ConsorcioSimulacaoCampoValor
                    valor={valor}
                /> 
            </GridItem3>
        </GridContainer>
    )
}

export const ConsorcioSimulacaoExibePerc = ({ label, perc}) => {

    return (
        <GridContainer>
            <GridItem1/>

            <GridItem6>
                <ConsorcioSimulacaoLabelCampo
                    label={label}
                />
            </GridItem6>

            <GridItem3>
                <ConsorcioSimulacaoCampoNumero
                    numero={formataPerc(perc, 2)}
                />
            </GridItem3>
        </GridContainer>
    )
}

export const ConsorcioSimulacaoExibePercValor = ({ label, params, perc, valor }) => {

    return (
        <GridContainer
            className={(params.report ? 'mt--2' : 'mt--6') + ' mb-2'}
        >
            <GridItem1/>

            <GridItem6>
                <ConsorcioSimulacaoLabelCampo
                    label={label}
                />
            </GridItem6>

            <GridItem2>
                <ConsorcioSimulacaoCampoNumero
                    numero={formataPerc(perc, 2)}
                />
            </GridItem2>

            <GridItem3>
                <ConsorcioSimulacaoCampoValor
                    valor={valor}
                />
            </GridItem3>
        </GridContainer>
    )
}

export const ConsorcioSimulacaoAdministradoraConsorcio = ({ item, ind, handleChange, params, report }) => {

    return (
        report
            ?
                params.SvgConsorcioLogoInstituicaoFinanceira
                    ?
                        <div
                            //className={'ml--' + params.linhaInstituicaoFinanceira.svgConsorcioLogoMl}
                        >
                            <params.SvgConsorcioLogoInstituicaoFinanceira/>
                        </div>
                    :
                        <ConsorcioSimulacaoCampoTexto
                            texto={pesquisaDescricaoList(administradoraConsorcioList(true), item.administradoraConsorcio)}
                        />
            :
                <TextFieldNumberSelectRequired
                    name={`objConsorcio.simulacao[${ind}].administradoraConsorcio`}
                    //label={LABEL.administradoraConsorcio}
                    value={item.administradoraConsorcio || ''}
                    onChange={handleChange}
                    list={administradoraConsorcioList(true)}
                />
    )
}

export const ConsorcioSimulacaoGrupoConsorcio = ({ item, ind, handleChange, report }) => {

    return (

        report
            ?
                <ConsorcioSimulacaoCampoTexto
                    texto={item.grupoConsorcio}
                />
            :
                <TextValidatorText
                    name={`objConsorcio.simulacao[${ind}].grupoConsorcio`}
                    //label={LABEL.grupoConsorcio}
                    value={item.grupoConsorcio || ''}
                    onChange={handleChange}
                    tamMax={TAMMAX.grupoConsorcio}
                />
    )
}

export const ConsorcioSimulacaoPessoaFisicaJuridica = ({ item, ind, handleChange, report }) => {

    return (
        
        report
            ?
                <ConsorcioSimulacaoCampoTexto
                    texto={pesquisaDescricaoList(pessoaFisicaJuridicaList, item.pessoaFisicaJuridica)}
                />
            :
                <TextFieldTextSelectRequired
                    name={`objConsorcio.simulacao[${ind}].pessoaFisicaJuridica`}
                    //label={LABEL.pessoaFisicaJuridica}
                    value={item.pessoaFisicaJuridica || ''}
                    onChange={handleChange}
                    list={pessoaFisicaJuridicaList}
                />
    )
}

export const ConsorcioSimulacaoValorCreditoConsorcio = ({ item, ind, handleChange, report }) => {

    return (

        report
            ?
                <ConsorcioSimulacaoCampoValor
                    valor={item.valorCreditoConsorcio}
                />
            :
                <TextValidatorValorRequired
                    name={`objConsorcio.simulacao[${ind}].valorCreditoConsorcio`}
                    //label={LABEL.valorCreditoConsorcio}
                    value={item.valorCreditoConsorcio === 0 ? 0 : item.valorCreditoConsorcio || ''}
                    onChange={handleChange}
                />
    )
}

export const ConsorcioSimulacaoValorUpGradeCreditoConsorcio = ({ item, ind, handleChange, report }) => {

    return (

        report
            ?
                <ConsorcioSimulacaoCampoValor
                    valor={item.valorUpGradeCreditoConsorcio}
                />
            :
                <TextValidatorValor
                    name={`objConsorcio.simulacao[${ind}].valorUpGradeCreditoConsorcio`}
                    //label={LABEL.valorUpGradeCreditoConsorcio}
                    value={item.valorUpGradeCreditoConsorcio === 0 ? 0 : item.valorUpGradeCreditoConsorcio || ''}
                    onChange={handleChange}
                />
    )
}

export const ConsorcioSimulacaoPrazoTotalGrupoConsorcio = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoNumero
                    numero={item.prazoTotalGrupoConsorcio}
                />
            :
                <TextValidatorNumberRequired
                    name={`objConsorcio.simulacao[${ind}].prazoTotalGrupoConsorcio`}
                    //label={LABEL.prazoAtualGrupoConsorcio}
                    value={item.prazoTotalGrupoConsorcio === 0 ? 0 : item.prazoTotalGrupoConsorcio || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.prazoTotalGrupoConsorcio}
                    numMax={NUMMAX.prazoTotalGrupoConsorcio}
                />
    )
}

export const ConsorcioSimulacaoPrazoOriginalGrupoConsorcio = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoNumero
                    numero={item.prazoOriginalGrupoConsorcio}
                />
            :
                <TextValidatorNumber
                    name={`objConsorcio.simulacao[${ind}].prazoOriginalGrupoConsorcio`}
                    //label={LABEL.prazoOriginalGrupoConsorcio}
                    value={item.prazoOriginalGrupoConsorcio === 0 ? 0 : item.prazoOriginalGrupoConsorcio || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.prazoTotalGrupoConsorcio}
                    numMax={NUMMAX.prazoTotalGrupoConsorcio}
                />
    )
}

export const ConsorcioSimulacaoParcelasAdesao = ({ item, ind, handleChange, list, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoTexto
                    texto={pesquisaDescricaoList(list, item.parcelasAdesao)}
                />
            :
                <TextFieldNumberSelectRequired
                    name={`objConsorcio.simulacao[${ind}].parcelasAdesao`}
                    //label={LABEL.adesao}
                    value={item.parcelasAdesao || ''}
                    onChange={handleChange}
                    list={list}
                />
    )
}

export const ConsorcioSimulacaoPercLanceRecursosProprios = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoPercInput
                    perc={item.percLanceRecursosProprios}
                />
            :
                <TextValidatorNumber
                    name={`objConsorcio.simulacao[${ind}].percLanceRecursosProprios`}
                    //label={LABEL.lanceRecursosProprios}
                    value={item.percLanceRecursosProprios === 0 ? 0 : item.percLanceRecursosProprios || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.perc}
                    numMax={NUMMAX.perc}
                />
    )
}

export const ConsorcioSimulacaoValorLanceRecursosPropriosInformado = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`objConsorcio.simulacao[${ind}].valorLanceRecursosPropriosInformado`}
            label={LABEL.valorLanceRecursosProprios}
            value={item.valorLanceRecursosPropriosInformado === 0 ? 0 : item.valorLanceRecursosPropriosInformado || ''}
            onChange={handleChange}
        />
    )
}

export const ConsorcioSimulacaoPercLanceEmbutido = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoPercInput
                    perc={item.percLanceEmbutido}
                />
            :
                <TextValidatorNumber
                    name={`objConsorcio.simulacao[${ind}].percLanceEmbutido`}
                    //label={LABEL.lanceEmbutido}
                    value={item.percLanceEmbutido === 0 ? 0 : item.percLanceEmbutido || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.perc}
                    numMax={NUMMAX.perc}
                />
    )
}

export const ConsorcioSimulacaoValorLanceEmbutidoInformado = ({ item, ind, handleChange }) => {

    return (
        <TextValidatorValor
            name={`objConsorcio.simulacao[${ind}].valorLanceEmbutidoInformado`}
            label={LABEL.valorLanceEmbutido}
            value={item.valorLanceEmbutidoInformado === 0 ? 0 : item.valorLanceEmbutidoInformado || ''}
            onChange={handleChange}
        />
    )
}

export const ConsorcioSimulacaoPercLanceIntegrado = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoPercInput
                    perc={item.percLanceIntegrado}
                />
            :
                <TextValidatorNumber
                    name={`objConsorcio.simulacao[${ind}].percLanceIntegrado`}
                    //label={LABEL.lanceIntegrado}
                    value={item.percLanceIntegrado === 0 ? 0 : item.percLanceIntegrado || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.perc}
                    numMax={NUMMAX.perc}
                />
    )
}

export const ConsorcioSimulacaoTipoLanceList = ({ item, ind, handleChange, list, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoLabelCampo
                    label={pesquisaDescricaoList(list, item.tipoLance)}
                />
            :
                <TextFieldTextSelectRequired
                    name={`objConsorcio.simulacao[${ind}].tipoLance`}
                    //label={LABEL.???}
                    value={item.tipoLance || ''}
                    onChange={handleChange}
                    list={list}
                />
    )
}

export const ConsorcioSimulacaoTipoLanceListPerc = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoPercInput
                    perc={item.percTipoLanceValor}
                />
            :
                <TextValidatorNumber
                    name={`objConsorcio.simulacao[${ind}].percTipoLanceValor`}
                    //label={LABEL.lanceIntegrado}
                    value={item.percTipoLanceValor === 0 ? 0 : item.percTipoLanceValor || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.perc}
                    numMax={NUMMAX.perc}
                />
    )
}

export const ConsorcioSimulacaoFormaAbaterLance = ({ item, ind, handleChange, report }) => {

    return (
        
        report
            ?
                <ConsorcioSimulacaoCampoTexto
                    texto={pesquisaDescricaoList(formaAbaterLanceList, item.formaAbaterLance)}
                />
            :
                <TextFieldTextSelectRequired
                    name={`objConsorcio.simulacao[${ind}].formaAbaterLance`}
                    //label={LABEL.formaAbaterLance}
                    value={item.formaAbaterLance || ''}
                    onChange={handleChange}
                    list={formaAbaterLanceList}
                />
    )
}

export const ConsorcioSimulacaoContemplacaoParcela = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoNumero
                    numero={item.contemplacaoParcela}
                />
            :
                <TextValidatorNumberRequired
                    name={`objConsorcio.simulacao[${ind}].contemplacaoParcela`}
                    //label={LABEL.contemplacaoParcela}
                    value={item.contemplacaoParcela === 0 ? 0 : item.contemplacaoParcela || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.prazoTotalGrupoConsorcio}
                    numMax={NUMMAX.prazoTotalGrupoConsorcio}
                />
    )
}

export const ConsorcioSimulacaoMesAnoPrimeiroReajuste = ({ label, item, ind, handleChange }) => {

    return (
        <TextValidatorMesAnoRequired
            name={`objConsorcio.simulacao[${ind}].mesAnoPrimeiroReajuste`}
            label={label}
            value={item.mesAnoPrimeiroReajuste || ''}
            onChange={handleChange}
        />
    )
}

export const ConsorcioSimulacaoTaxaAnual = ({ label, item, ind, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name={`objConsorcio.simulacao[${ind}].taxaAnual`}
            label={label}
            value={item.taxaAnual === 0 ? 0 : item.taxaAnual || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxa}
            numMax={NUMMAX.taxa}
        />
    )
}

export const ConsorcioSimulacaoParcelaTCV = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoNumero
                    numero={item.parcelasTCV}
                />
            :
                <TextValidatorNumber
                    name={`objConsorcio.simulacao[${ind}].parcelasTCV`}
                    //label={LABEL.parcelasTCV}
                    value={item.parcelasTCV === 0 ? 0 : item.parcelasTCV || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.prazoTotalGrupoConsorcio}
                    numMax={NUMMAX.prazoTotalGrupoConsorcio}
                />
    )
}

//export const ConsorcioSimulacaoTipoGrupoConsorcio = ({ item, ind, handleChange, report }) => {

//    return (
        
//        report
//            ?
//                <ConsorcioSimulacaoCampoTexto
//                    texto={pesquisaDescricaoList(tipoGrupoConsorcioList, item.tipoGrupoConsorcio)}
//                />
//            :
//                <TextFieldTextSelectRequired
//                    name={`objConsorcio.simulacao[${ind}].tipoGrupoConsorcio`}
//                    //label={LABEL.tipoGrupoConsorcio}
//                    value={item.tipoGrupoConsorcio || ''}
//                    onChange={handleChange}
//                    list={tipoGrupoConsorcioList}
//                />
//    )
//}

export const ConsorcioSimulacaoTaxaAdesao = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoPercInput
                    perc={item.taxaAdesao}
                />
            :
                <TextValidatorNumberRequired
                    name={`objConsorcio.simulacao[${ind}].taxaAdesao`}
                    //label={LABEL.taxaAdesao}
                    value={item.taxaAdesao === 0 ? 0 : item.taxaAdesao || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.perc}
                    numMax={NUMMAX.perc}
                />
    )
}

export const ConsorcioSimulacaoTaxaAdministracao = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoPercInput
                    perc={item.taxaAdministracao}
                />
            :
                <TextValidatorNumberRequired
                    name={`objConsorcio.simulacao[${ind}].taxaAdministracao`}
                    //label={LABEL.taxaAdministracao}
                    value={item.taxaAdministracao === 0 ? 0 : item.taxaAdministracao || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.perc}
                    numMax={NUMMAX.perc}
                />
    )
}

export const ConsorcioSimulacaoPercFundoReserva = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoPercInput
                    perc={item.percFundoReserva}
                />
            :
                <TextValidatorNumberRequired
                    name={`objConsorcio.simulacao[${ind}].percFundoReserva`}
                    //label={LABEL.percFundoReserva}
                    value={item.percFundoReserva === 0 ? 0 : item.percFundoReserva || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.perc}
                    numMax={NUMMAX.perc}
                />
    )
}

export const ConsorcioSimulacaoFundoReservaSeraDevolvidoFinal = ({ label, item, ind, handleChange, report }) => {

    return (
        <CheckboxPadrao
            name={`objConsorcio.simulacao[${ind}].fundoReservaSeraDevolvidoFinal`}
            label={label}
            checked={item.fundoReservaSeraDevolvidoFinal}
            onChange={handleChange}
            disabled={report}
        />
    )
}

export const ConsorcioSimulacaoMesesDevolucaoFundoReserva = ({ label, item, ind, handleChange, report }) => {

    return (
        <TextValidatorNumberRequired
            name={`objConsorcio.simulacao[${ind}].mesesDevolucaoFundoReserva`}
            label={label}
            value={item.mesesDevolucaoFundoReserva === 0 ? 0 : item.mesesDevolucaoFundoReserva || ''}
            onChange={handleChange}
            numMin={NUMMIN.mesesDevolucaoFundoReserva}
            numMax={NUMMAX.mesesDevolucaoFundoReserva}
            disabled={report}
        />
    )
}

export const ConsorcioSimulacaoPercDevolucaoFundoReserva = ({ label, item, ind, handleChange, report }) => {

    return (
        <TextValidatorNumberRequired
            name={`objConsorcio.simulacao[${ind}].percDevolucaoFundoReserva`}
            label={label}
            value={item.percDevolucaoFundoReserva === 0 ? 0 : item.percDevolucaoFundoReserva || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
            disabled={report}
        />
    )
}

export const ConsorcioSimulacaoPercSeguroPrestamista = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoPercInput
                    perc={item.percSeguroPrestamista}
                    casasDecimais={3}
                />
            :
                <TextValidatorNumberRequired
                    name={`objConsorcio.simulacao[${ind}].percSeguroPrestamista`}
                    //label={LABEL.percSeguroPrestamista}
                    value={item.percSeguroPrestamista === 0 ? 0 : item.percSeguroPrestamista || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.perc}
                    numMax={NUMMAX.perc}
                />
    )
}

export const ConsorcioSimulacaoPercRedutoParcela = ({ item, ind, handleChange, report }) => {

    return (
        report
            ?
                <ConsorcioSimulacaoCampoPercInput
                    perc={item.percRedutorParcela}
                />
            :
                <TextValidatorNumber
                    name={`objConsorcio.simulacao[${ind}].percRedutorParcela`}
                    //label={LABEL.percRedutorParcela}
                    value={item.percRedutorParcela === 0 ? 0 : item.percRedutorParcela || ''}
                    onChange={handleChange}
                    numMin={NUMMIN.perc}
                    numMax={NUMMAX.perc}
                />
    )
}


export const ConsorcioSimulacaoAnalisarAluguelAposContemplacao = ({ label, item, ind, handleChange, report }) => {

    return (
        <CheckboxPadrao
            name={`objConsorcio.simulacao[${ind}].analisarAluguelAposContemplacao`}
            label={label}
            checked={item.analisarAluguelAposContemplacao}
            onChange={handleChange}
            disabled={report}
        />
    )
}


export const ConsorcioSimulacaoMesesIniciarAluguelAposContemplacao = ({ label, item, ind, handleChange, report }) => {

    return (
        <TextValidatorNumberRequired
            name={`objConsorcio.simulacao[${ind}].mesesIniciarAluguelAposContemplacao`}
            label={label}
            value={item.mesesIniciarAluguelAposContemplacao === 0 ? 0 : item.mesesIniciarAluguelAposContemplacao || ''}
            onChange={handleChange}
            numMin={NUMMIN.mesesIniciarAluguelAposContemplacao}
            numMax={NUMMAX.mesesIniciarAluguelAposContemplacao}
            disabled={report}
        />
    )
}


export const ConsorcioSimulacaoPercAluguelMensalAposContemplacao = ({ label, item, ind, handleChange, report }) => {

    return (
        <TextValidatorNumberRequired
            name={`objConsorcio.simulacao[${ind}].percAluguelMensalAposContemplacao`}
            label={label}
            value={item.percAluguelMensalAposContemplacao === 0 ? 0 : item.percAluguelMensalAposContemplacao || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
            disabled={report}
        />
    )
}


export const ConsorcioSimulacaoPercReajusteAluguelAnualAposContemplacao = ({ label, item, ind, handleChange, report }) => {

    return (
        <TextValidatorNumberRequired
            name={`objConsorcio.simulacao[${ind}].percReajusteAluguelAnualAposContemplacao`}
            label={label}
            value={
                item.percReajusteAluguelAnualAposContemplacao === 0
                    ?
                        0
                    :
                        item.percReajusteAluguelAnualAposContemplacao || ''
            }
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
            disabled={report}
        />
    )
}


export const ConsorcioSimulacaoPercValorizacaoImovelAluguelAposContemplacao = ({ label, item, ind, handleChange, report }) => {

    return (
        <TextValidatorNumber
            name={`objConsorcio.simulacao[${ind}].percValorizacaoImovelAluguelAposContemplacao`}
            label={label}
            value={item.percValorizacaoImovelAluguelAposContemplacao === 0 ? 0 : item.percValorizacaoImovelAluguelAposContemplacao || ''}
            onChange={handleChange}
            numMin={NUMMIN.perc}
            numMax={NUMMAX.perc}
            disabled={report}
        />
    )
}



export const ConsorcioSimulacaoValorImovelAluguelAposContemplacao = ({ label, item, ind, handleChange, report }) => {

    return (
        <TextValidatorValor
            name={`objConsorcio.simulacao[${ind}].valorImovelAluguelAposContemplacao`}
            label={label}
            value={item.valorImovelAluguelAposContemplacao === 0 ? 0 : item.valorImovelAluguelAposContemplacao || ''}
            onChange={handleChange}
            disabled={report}
        />
    )
}



export const ConsorcioSimulacaoAnalisarVendaAposQuitacao = ({ label, item, ind, handleChange, report }) => {

    return (
        <CheckboxPadrao
            name={`objConsorcio.simulacao[${ind}].analisarVendaAposQuitacao`}
            label={label}
            checked={item.analisarVendaAposQuitacao}
            onChange={handleChange}
            disabled={report}
        />
    )
}

export const ConsorcioSimulacaoMesesVendaAposQuitacao = ({ label, item, ind, handleChange, report }) => {

    return (
        <TextValidatorNumberRequired
            name={`objConsorcio.simulacao[${ind}].mesesVendaAposQuitacao`}
            label={label}
            value={item.mesesVendaAposQuitacao === 0 ? 0 : item.mesesVendaAposQuitacao || ''}
            onChange={handleChange}
            numMin={NUMMIN.mesesVendaAposQuitacao}
            numMax={NUMMAX.mesesVendaAposQuitacao}
            disabled={report}
        />
    )
}